/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/promise-function-async */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-curly-brace-presence */

'use client'

import React, { Suspense } from 'react'
import Image from 'next/image'
import { Lob } from '@enums/Lob'
import { ACKO_LOGO_HORIZONTAL_GRADIENT_DARK, ACKO_LOGO_HORIZONTAL_GRADIENT_WHITE } from '@components/utils/ackoLogoUrls'
import { isVasWidget } from '@helpers/vasLandingPageHelper'
import Link from 'next/link'
import { BASE_URL } from '@components/MainWidget/common/commonConstants'
import { NEWCAR_SEM_PAGE } from '@configs/components.config'
import HomeHeader from '@components/HomeHeader'
import { headerData } from '@constants/commonHeaderData'
import styles from './productNav.module.scss'

const lobSemNavBarRequired = {
  [Lob.TRAVEL]: true,
}

const HeaderDesktopAndMweb = ({
  isSemPage = false,
  lob = null,
  data,
  isMobile = true,
  isLoggedIn = false,
}: {
  isSemPage?: boolean
  lob?: any
  data?: any
  isMobile?: boolean
  isLoggedIn?: boolean
}) => {
  const content = data?.data?.attributes
  const isVasLandingWidget = isVasWidget(content?.widget)
  const renderMinimalNavBar = (isSemPage && lob && lobSemNavBarRequired[lob]) || (isVasLandingWidget && !!isSemPage)

  if (content?.widget === NEWCAR_SEM_PAGE) {
    // the header(acko logo) is in the widget
    return null
  }

  return (
    <Suspense fallback={<div className={styles.loaderStyles} />}>
      {renderMinimalNavBar ? (
        <div className={styles.semNavbar}>
          <Link href={BASE_URL}>
            <Image
              width={100}
              height={24}
              src={
                content?.theme !== 'light' ? ACKO_LOGO_HORIZONTAL_GRADIENT_DARK : ACKO_LOGO_HORIZONTAL_GRADIENT_WHITE
              }
              alt="Acko Company Logo"
              priority
            />
          </Link>
        </div>
      ) : (
        <HomeHeader isLoggedIn={isLoggedIn} isMobile={isMobile} data={headerData} />
      )}
    </Suspense>
  )
}

export default HeaderDesktopAndMweb
